import { useEffect, useState } from 'react';

const useTabActive = () => {
	const [hasFocus, setHasFocus] = useState(true);

	useEffect(() => {
		const onFocus = () => {
			setHasFocus(true);
		};
		const onBlur = () => {
			setHasFocus(false);
		};

		window.addEventListener('focus', onFocus);
		window.addEventListener('blur', onBlur);

		return () => {
			window.removeEventListener('focus', onFocus);
			window.removeEventListener('blur', onBlur);
		};
	}, []);

	return hasFocus;
};

export default useTabActive;
